import { EventEmitter } from 'fbemitter'

class CableEmitter extends EventEmitter {

}

export default new CableEmitter()
